import {connect} from "react-redux";
import {Modal} from "bootstrap";
import AppBaseComponent from '../../../../components/AppBaseComponent';
import HttpAPICall from "../../../../services/HttpAPICall";
import Loader from "../../../../components/ui/Loader/Loader";
import tapIcon from "../../../../services/TapIcon";
import { INVENTORY_API_BASE_URL_2, ORG_API_BASE_URL_2 } from "../../../../services/TapApiUrls";
import Ax from "../../../../components/hoc/Ax";
import {toast} from "react-toastify";
import Status from "../../../../components/ui/Status";
import React from "react";
import {number} from "prop-types";
import swal from "sweetalert";
import { Link } from 'react-router-dom';


class GeneralSettings extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.initGeneralConfigForm      =   {
            quote_enable_tcs                            :   'N',
            quote_enable_authorized_signatory           :   'N',
            quote_enable_system_generated_quotation_id  :   'N',
            include_manufaturer_name_quotation_pdf_for_customer : 'N',
            include_mpn_quotation_pdf_for_customer      :   'N',
            include_tags_quotation_pdf_for_customer     :   'N',
        };

        this.configData     =   [
            { key : "quote_enable_tcs", value : "Enable TCS"},
            { key : "quote_enable_authorized_signatory", value : "Enable Authorized Signatory"},
            { key : "quote_enable_system_generated_quotation_id", value : "Enable System Generated Quotation ID"},
            { key : "include_manufaturer_name_quotation_pdf_for_customer", value : "Include Manufacturer Name in Quotation PDF for Customer"},
            { key : "include_mpn_quotation_pdf_for_customer", value : "Include MPN in Quotation PDF for Customer"},
            { key : "include_tags_quotation_pdf_for_customer", value : "Include Tags in Quotation PDF for Customer"}
        ];

        this.state                      =   {
            generalConfigloading            :   false,
            general_config_list             :   null,
            generalConfigForm               :   {...this.initGeneralConfigForm},
            editFormSubmiting               :   false,
            current_key                     :   '',
            configData                      :   this.configData,
        };

        

        this.settingEditUrl =   INVENTORY_API_BASE_URL_2  + '/quotation_setting/edit';
        this.settingUrl     =  INVENTORY_API_BASE_URL_2  + '/quotation_setting';

    }

    componentDidMount() {
        this.getGeneralSettingListing();
        this.editGeneralConfiguration        =        new Modal(document.getElementById('editGeneralConfigurationModal'), {keyboard: false, backdrop :false});
   }

    getGeneralSettingListing = () => {
        let params = {
            keys : ['quote_enable_tcs','quote_enable_authorized_signatory','quote_enable_system_generated_quotation_id', 'include_manufaturer_name_quotation_pdf_for_customer', 'include_mpn_quotation_pdf_for_customer', 'include_tags_quotation_pdf_for_customer'],
        }
        this.setState({ generalConfigloading: true });
        HttpAPICall.withAthorization('GET', this.settingUrl, this.props.access_token, {...params}, {}, (resp) => {
            this.setState({ general_config_list: resp.data.data },() => {
                let data = this.state.general_config_list;
                if(this.props.enableQuotationId && data && data.quote_enable_system_generated_quotation_id){
                    this.props.enableQuotationId(data.quote_enable_system_generated_quotation_id)

                }
            })
        }).then(() => this.setState({ generalConfigloading: false }));
    }

    editGeneralConfigurationInit = (key = null) => {
        this.editGeneralConfiguration.show();
        if(this.state.general_config_list) {
            let generalConfigForm = [];
            if (this.state.general_config_list) {
                Object.entries(this.state.general_config_list).forEach(([key, value]) => {
                  let name = key;
                  let val = value;
                  generalConfigForm[name] = val;
                });
            }
            this.setState({
                generalConfigForm   :   generalConfigForm,
                configData          :   key ? this.configData.filter(d => d.key === key) : this.configData,
                current_key         :   key
            });
        }
    }

    submitGeneralConfigurationForm        =    (e)          =>     {
        e.preventDefault();
        this.setState({editFormSubmiting : true});
        HttpAPICall.withAthorization('PUT', this.settingEditUrl, this.props.access_token, {} , this.state.generalConfigForm , (response) => {
            toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
            this.editGeneralConfiguration.hide();
            this.getGeneralSettingListing();
        }).then(() => this.setState({editFormSubmiting: false}));
    }

    editGeneralConfigurationModalJsx      =    ()           =>     {        
        return (
            <div className="modal fade" id="editGeneralConfigurationModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addAssetModalLabel">Edit General Configuration</h5>
                        </div>
                        <form onSubmit={this.submitGeneralConfigurationForm}>
                            <div className="modal-body p-3">
                                {
                                    this.state.configData.map((config) => {
                                        return (
                                        <div className="row align-items-center mb-2 mt-2 px-2" key={config.key}>
                                            <div className="col-md-9">
                                                <label className="form-label">{config.value}</label>
                                            </div>
                                            <div className="col-md-1">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name={config.key}
                                                        value="Y"
                                                        onChange={(e) => this.formInputHandler(e, "generalConfigForm")}
                                                        checked={this.state.generalConfigForm[config.key] === "Y"}
                                                    /> Yes
                                                </label>
                                            </div>
                                            <div className="col-md-2">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name={config.key}
                                                        value="N"
                                                        onChange={(e) => this.formInputHandler(e, "generalConfigForm")}
                                                        checked={this.state.generalConfigForm[config.key] === "N"} /> No
                                                </label>
                                            </div>
                                        </div>
                                        )
                                    })
                                }
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" disabled={this.state.editFormSubmiting} data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary" disabled={this.state.editFormSubmiting} >Save {this.state.editFormSubmiting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : null}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
  }

    generalConfigurationJsx               =    ()           =>     {
        let data = this.state.general_config_list;
        return (<table className="table table-hover table-bordered my-4 ">
            <thead className="table-secondary">
                <tr className="text-center">
                    <th scope="col" style={{ width: "5%" }}>S.No</th>
                    <th scope="col" className="text-start">Configuration</th>
                    <th scope="col" style={{ width: "25%" }} >Value</th>
                    <th scope="col" style={{ width: "10%" }} >Action</th>
                </tr>
            </thead>
            <tbody>
            {
                this.configData.map((conf, i) => (
                    <tr key={conf.key}>
                        {
                            data && Object.keys(data).includes(conf.key) &&
                            <>
                                <td>{i+1}</td>
                                <td className="text-start">{conf.value}</td>
                                <td>{data[conf.key] == 'Y' ? "Yes" : "No"}</td>
                                <td> <span className="dropdown">
                                    <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn">
                                        <tapIcon.FontAwesomeIcon icon={tapIcon.faEllipsisV} />
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><a className="dropdown-item" role="button" onClick={() => this.editGeneralConfigurationInit(conf.key)}>Edit</a></li>
                                    </ul>
                                    </span>
                                </td>
                            </>

                        }
                    </tr>
                ))
            }
            </tbody>
        </table>)
    }

    render                                  =     ()           =>     {
        return (<Ax>
            <div className="tab_content_wrapper mt-2"><span className="content_heading">General Configuration</span>
                <div className="text-end "><button className="btn btn-primary" disabled={!this.props.permissions.includes('isc-configuration-edit')}  onClick={() => this.editGeneralConfigurationInit(null)}>Edit </button></div>
            </div>
            {this.state.generalConfigloading ? <Loader />
                : this.generalConfigurationJsx()}
            {this.editGeneralConfigurationModalJsx()}
            
        </Ax>);
    }

}


const mapStateToProps = state => {
    return {
        access_token            :        state.auth.access_token,
        permissions             :       state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []
    };
};

export default connect(mapStateToProps)(GeneralSettings);